import { PureComponent, Fragment } from "react";
import Select from "react-select";
import SelectStyle from "/components/templates-generator/fields/dropdown/react-select.scss.js";
import { INDUSTRIES_CONFIG, getIndustryOptionByValue } from "services/industries/industries-service";
import classnames from "classnames";
import ManageOptionsComponent from "/components/segments/industry-selection/manage-options/manage-options-component";
import ArrowRight from "/static/svg/arrow-right.svg";

import { componentStyles, stepNumberStyles } from "./industry-selection-first-step-component.scss";

export default class IndustrySelectionFirstStepComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onNextClick = this.onNextClick.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
  }

  renderStepNumber(stepNumber) {
    return (
      <Fragment>
        <div className="step-number-circle">{stepNumber}</div>
        <style jsx>{stepNumberStyles}</style>
      </Fragment>
    );
  }

  renderIndustryQuestion() {
    const { selectedIndustry, handleSelectIndustryChange } = this.props;
    const questionHtml = INDUSTRIES_CONFIG.firstStepHtmlTitle;

    return (
      <div className={classnames("industry-question-wrapper", { "industry-selected": !!selectedIndustry })}>
        {this.renderStepNumber(1)}
        <div className="industry-question" dangerouslySetInnerHTML={{ __html: questionHtml }} />
        <div className="industry-selection-options-wrapper">
          <Select
            name="industry-options"
            isClearable={false}
            isSearchable={false}
            styles={{
              control: (base) => {
                return {
                  ...base,
                  fontSize: "14px",
                  height: "40px",
                  boxShadow: "none",
                  minWidth: "320px"
                };
              }
            }}
            placeholder={"Choose one from the list"}
            value={selectedIndustry}
            onChange={handleSelectIndustryChange}
            options={INDUSTRIES_CONFIG.options}
          />
          <style jsx>{SelectStyle}</style>
        </div>
      </div>
    );
  }

  renderManageOptionsQuestion() {
    const { selectedIndustry, selectedManageOptions, handleOptionsSelected, onNextClick } = this.props;
    const questionHtml = INDUSTRIES_CONFIG.secondStepHtmlTitle;
    const diclaimer = INDUSTRIES_CONFIG.selectionDisclaimerHtml;
    const industryData = getIndustryOptionByValue(selectedIndustry) || {};

    return (
      <div className={classnames("manage-question-wrapper", { visible: !!selectedIndustry })}>
        {this.renderStepNumber(2)}
        <div className="manage-options-question" dangerouslySetInnerHTML={{ __html: questionHtml }} />
        <div className="select-disclaimer" dangerouslySetInnerHTML={{ __html: diclaimer }} />

        <ManageOptionsComponent
          options={industryData.manageOptions || []}
          selectedOptions={selectedManageOptions}
          onSelect={handleOptionsSelected}
        />
      </div>
    );
  }

  onNextClick() {
    const { nextStepCallback } = this.props;
    nextStepCallback();
  }

  renderNextButton() {
    const { selectedManageOptions } = this.props;

    return (
      <div
        className={classnames("next-wrapper", {
          visible: selectedManageOptions.length > 0
        })}
      >
        <a className="next-link" onClick={this.onNextClick}>
          <div className="next-circle">
            <ArrowRight className="arrow" />
          </div>
          <div className="next-link">Next</div>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="industry-selection-first-step-wrapper">
        <div className="industry-selection-questions">
          {this.renderIndustryQuestion()}
          {this.renderManageOptionsQuestion()}
        </div>
        {this.renderNextButton()}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
